import { BankEnum } from "../models/SelectOptions";

export const CONFIGCAT_KEYS = {
    VARIANT: {
        A: 'variant_a',
        B: 'variant_b',
        C: 'variant_c'
    },
    SHOW_BANNER: {
        key: 'showbanner',
        defaultValue: false
    },
    BANNER_TEXT: {
        key: 'bannertext',
        defaultValue: '{}'
    },
    DEATH_BENEFIT_LANDING_PAGE_VARIANT: {
        key: 'deathbenefitlandingpagevariant',
        defaultValue: 'variant_a',
    },
    SHOW_REPAY_EFT_DEPRECATION_BANNER: {
        key: 'showrepayeftdeprecationbanner',
        defaultValue: true
    },
    DEATH_BENEFIT_NAME_VARIANT: {
        key: 'deathbenefitnamevariant',
        defaultValue: { "variant": "a", "name": "Death Benefit" },
    },
    DEATH_BENEFIT_JOURNEY_VARIANT: {
        key: 'deathbenefitjourneyvariant',
        defaultValue: 'show_death_benefit_page',
        variants: {
            SHOW: 'show_death_benefit_page',
            SKIP: 'skip_death_benefit_page'
        }
    },
    LOAN_WEB_VERSION: {
        key: 'loanwebversion',
        defaultValue: 'release/dev'
    },
    TOGGLE_VERSION_CHECKER: {
        key: 'toggleversionchecker',
        defaultValue: false
    },
    TOGGLE_LOGIN_WITH_OTP_DEFAULT: {
        key: 'toggleloginwithotpdefault',
        defaultValue: false
    },
    TOGGLE_EMAIL_AUTOCOMPLETE: {
        key: 'toggleemailautocomplete',
        defaultValue: false
    }
    ,
    EMAIL_AUTOCOMPLETE_DOMAINS: {
        key: 'emailautocompletedomains',
        defaultValue: ["gmail.com", "outlook.com"]
    },
    STL_EXCLUDED_REPAYMENT_DATES: {
        key: 'stlexcludedrepaymentdates',
        defaultValue: []
    },
    GOOGLE_PLACES_DEBOUNCE_MS: {
        key: 'googleplacesdebouncems',
        defaultValue: 300
    },
    // We default to the big 5 in case of an issue
    SUPPORTED_BANKS: {
        key: 'supportedbanks',
        defaultValue: [BankEnum.ABSA, BankEnum.Capitec, BankEnum.FirstNationalBank, BankEnum.Nedbank, BankEnum.StandardBank]
    },
    CAPITEC_OPEN_BANKING: {
        key: 'capitecopenbanking',
        defaultValue: true
    },
    ENABLE_LEGAL_BRILLIANCE: {
        key: 'enableLegalBrilliance',
        defaultValue: false
    }
}
